import styled from 'styled-components';
import { vw } from 'components/common/Common';

export const JetCardMain = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fdfeff;
`;

export const P = styled.p`
  font-size: ${(props) => vw(props.$fontSize || 20)};
  font-weight: 400;
  line-height: 1.5;
  color: ${(props) => props.$color || '#000'};
  width: 100%;
  margin: ${vw(10)} 0;
  text-align: ${(props) => props.$align};
`;

export const SvgIcon = styled.img`
  width: ${(props) => vw(props.$size)};
  height: ${(props) => vw(props.$size)};
`;

export const H1 = styled.h1`
  font-size: 64px;
  font-weight: 600;
  line-height: 1;
  color: #050a30;
  margin: 0 0;

  @media (max-width: 768px) {
    font-size: 48px;
  }

  @media (max-width: 480px) {
    font-size: 36px;
  }
`;

export const H2 = styled.h2`
  font-size: ${vw(48)};
  color: ${(props) => props.$color || '#000'};
  font-weight: 700;
  width: 100%;
  text-align: ${(props) => props.$align};
`;

export const H3 = styled.h3`
  font-size: ${(props) => props.$fontSize || '32px'};
  color: #000;
  font-weight: 600;
  width: 100%;
  margin: 0 0;
`;

export const Li = styled.li`
  font-size: ${vw(16)};
  color: #000;
  font-weight: 500;
  width: 100%;
  list-style-type: none;
`;

export const Link = styled.a`
  display: block;
  border: 2px solid ${(props) => props.$borderColor || '#000'};
  padding: ${vw(6)} ${vw(24)};
  border-radius: ${vw(16)};
  font-size: ${vw(20)};
  font-weight: ${(props) => props.$weight || 500};
  line-height: 1.5;
  color: ${(props) => props.$color || '#000'};
  text-decoration: none;
  width: fit-content;
  :hover {
    color: ${(props) => props.$color || '#000'};
    border-color: ${(props) => props.$color || '#000'};
  }
`;

export const Span = styled.span`
  display: block;
  font-size: ${vw(20)};
  font-weight: ${(props) => props.$weight || 400};
  line-height: 1.5;
  color: #000;
`;
